/*
 * Copyright (c) 2022, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import {usePage} from '@salesforce/commerce-sdk-react'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import PDHomePage from '../../page-designer/pages/home'
import {HTTPError} from '@salesforce/pwa-kit-react-sdk/ssr/universal/errors'
import {MAX_CACHE_AGE, PD_HOMEPAGE_ID, STALE_WHILE_REVALIDATE} from '../../../app/constants'
import HomePage from './partials/home-page'

/**
 * This is the home page (Page designer or regular) for Retail React App.
 * The page renders SEO metadata and a few promotion
 * categories and products, data is from local file.
 */
const Home = () => {
    const {res} = useServerContext()
    if (res) {
        res.set(
            'Cache-Control',
            `s-maxage=${MAX_CACHE_AGE}, stale-while-revalidate=${STALE_WHILE_REVALIDATE}`
        )
    }

    /******* Page designer Page based on page ID ****/
    const {data: page, error} = usePage({
        parameters: {
            pageId: PD_HOMEPAGE_ID
        },
        staleTime: 12 * 60 * 60 * 1000, // cache for 12 hrs
        cacheTime: 24 * 60 * 60 * 1000 // keep in cache for 24hr
    })

    if (error && error?.response?.status !== 404) {
        throw new HTTPError(error.response?.statusText)
    }

    const isPageDesignerPage = page?.regions?.length > 0
    if (isPageDesignerPage) {
        return <PDHomePage pdPage={page} />
    } else {
        return <HomePage />
    }
}

Home.getTemplateName = () => 'home'

export default Home
